import * as Sentry from '@sentry/vue';
import { BrowserTracing } from '@sentry/tracing';
import router from '../../../router';
import { Vue } from '@sentry/vue/types/types';

export default function useSentry() {
  const init = (app: Vue): void => {
    if (import.meta.env.MODE === 'production') {
      Sentry.init({
        app,
        dsn: 'https://06d408223ca94f358e8ad2f3426095c9@o213745.ingest.sentry.io/6442911',
        integrations: [
          new BrowserTracing({
            routingInstrumentation: Sentry.vueRouterInstrumentation(router),
            tracingOrigins: [
              'localhost',
              'app.pms2.test',
              'pms.dev.artificialgroup.com',
              /^\//,
            ],
          }),
        ],
        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        // We recommend adjusting this value in production
        tracesSampleRate: 0,
      });
    }
  };

  return {
    init,
  };
}
